<div class="flex flex-col">
  <h3 class="text-gray-500 pl-2 text-sm mt-2">Events</h3>
  <a
    class="hover:bg-orangeLightX text-sm text-gray-700 py-2 pl-2 font-bold flex items-center gap-2"
    [routerLink]="['events']"
  >
    <mat-icon>event</mat-icon>
    alle Events
  </a>
</div>
